export default __webpack_public_path__ + "assets/images/logo2.png";